// src/config/about/content.js

export const aboutContent = {
  hero: {
    title: "About SHIXIAO & YOLEE",
    subtitle:
      "Engineering excellence in abrasive belt converting line, flap discs production line and fiberglass backing plates machinery — manufactured by SHIXIAO and represented globally by YOLEE.",
  },

  factory: {
    title: "Production & Technical Strength",
    lead: "SHIXIAO operates modern, ISO-aligned manufacturing facilities with precision CNC centers, automated abrasive lines and dedicated test cells.",
    strengths: [
      "Precision machining: multi-axis CNC and automated finishing cells.",
      "Motion & control: servo drives, PLC systems and standardized wiring.",
      "R&D & integration: in-house control logic, HMI and robot integration.",
      "Quality & traceability: end-of-line testing and process documentation.",
    ],
  },

  history: [
    {
      year: "2006",
      title: "Founding of SHIXIAO Machinery",
      text: "SHIXIAO was established to develop reliable abrasive machinery and whole production line for local plants of abrasive processing.",
    },
    {
      year: "2014",
      title: "Capacity & Automation",
      text: "Investment in CNC centers and automated feeding increased capacity and consistency for export-grade products.",
    },
    {
      year: "2019",
      title: "YOLEE Founded (ESR)",
      text: "YOLEE was founded as the exclusive overseas sales representative, focusing on technical sales and direct factory support.",
    },
    {
      year: "2024",
      title: "R&D & Quality Improvements",
      text: "Expanded research into abrasive blends, backing plate performance and production automation to meet global standards.",
    },
  ],
};
